module.exports = __webpack_public_path__ + "static/media/icon-light-background.d8b241b3.svg";